import { gql } from '../../utils/helper';

export const createSubjectStoryClaims = gql`
  mutation InsertClaims($subjectStoryClaimsList: [subjectStoryClaims_insert_input!]!) {
    insert_subjectStoryClaims(
      objects: $subjectStoryClaimsList
      on_conflict: {
        constraint: subjectStoryClaims_subjectId_subjectType_storyId_key
        update_columns: [storyClaims, updatedAt]
      }
    ) {
      affected_rows
    }
  }
`;

export const createSubjectPublicationClaims = gql`
  mutation InsertClaims($subjectPublicationClaimsList: [subjectPublicationClaims_insert_input!]!) {
    insert_subjectPublicationClaims(
      objects: $subjectPublicationClaimsList
      on_conflict: {
        constraint: subjectPublicationClaims_subjectId_subjectType_publicationI_key
        update_columns: [publicationClaim, sectionIds, updatedAt]
      }
    ) {
      affected_rows
    }
  }
`;

export const getSubjectStoryClaimsByStoryId = gql`
  query GetSubjectStoryClaimsByStoryId($storyId: String!) {
    subjectStoryClaims(where: { storyId: { _eq: $storyId } }) {
      subjectId
      subjectType
      storyId
      storyClaims
    }
  }
`;

export const getSubjectStoryClaimsByStoryIdSubjectId = gql`
  query GetSubjectStoryClaimsByStoryId($storyId: String!, $subjectId: uuid!) {
    subjectStoryClaims(where: { storyId: { _eq: $storyId }, subjectId: { _eq: $subjectId } }) {
      subjectId
      subjectType
      storyId
      storyClaims
    }
  }
`;

export const getSubjectStoryClaimsByStoryIdsSubjectIds = gql`
  query GetSubjectStoryClaimsByStoryIdsSubjectIds($storyIds: [String!]!, $subjectIds: [uuid!]!) {
    subjectStoryClaims(where: { storyId: { _in: $storyIds }, subjectId: { _in: $subjectIds } }) {
      subjectId
      subjectType
      storyId
      storyClaims
    }
  }
`;

export const deleteSubjectStoryClaim = gql`
  mutation deleteClaim($subjectIds: [uuid!], $storyId: String) {
    delete_subjectStoryClaims(where: {subjectId: {_in: $subjectIds}, storyId: {_eq: $storyId}}) {
      affected_rows
    }
  }
`;

export const deleteSubjectPublicationClaim = gql`
  mutation deleteClaim($subjectIds: [uuid!], $publicationId: uuid!) {
    delete_subjectPublicationClaims(where: {subjectId: {_in: $subjectIds}, publicationId: {_eq: $publicationId}}) {
      affected_rows
    }
  }
`;
